<template>

    <div class="filter-bar" :class="loading ? 'bg-light-grey' : 'bg-charcoal'">

        <div v-if="!loading">
            <BasicFilterForm :post-type="postType" class="f1" />
        </div>

        <MoonSpinner v-else :loading="true"/>

    </div>

</template>

<script>

    import BasicFilterForm from "@/components/forms/BasicFilterForm";

    import MoonSpinner from "@/components/spinners/MoonSpinner";

    import {mapGetters,mapActions} from 'vuex';

    export default {
        name: 'ArchiveFilter',
        components: {
            BasicFilterForm, MoonSpinner
        },

        props: {
            postType: {
                type: String,
                required: false,
                default: 'Blog'
            }
        },

        computed: {
            ...mapGetters('Taxonomies', ['loading']),
        },

        created() {
            this.loadData();
        },

        methods: {
            ...mapActions('Taxonomies', ['getFilters']),
            loadData() {
                this.getFilters(this.postType);
            }
        }
    }

</script>
